// extracted by mini-css-extract-plugin
export default {"additionalItemsHeader":"views-ProductPage-addonServices-components-itemSection-styles__additionalItemsHeader--jwEx0"};